/**
 * @fileoverview
 * Front end Mod 11 validation for Brazil national Id
 * For more info: {@link https://crosstec.org/en/forums/3-breezingforms-for-joomla/66739-validation-and-mask-to-brazilian-document-cpf.html?start=6}
 *
 */

export default {
  name: 'national_id',
  /**
   *
   * @param {String} value - National Id that we receive from the user
   *
   * @returns {Boolean} - Returns Boolean value for Mod11 validation check
   */
  validator(value) {
    const valueArray = Array.from(value, (val) => Number(val))

    /**
     * Weighted sum of the first 9 digits of the national ID to create the 10th check digit
     * If mod 11 of the weighted sum is less than 2, return 0, else subtract mod 11 of the weighted sum from 11
     */
    const reducer1 = (accumulator, currentValue, index) => accumulator + currentValue * (10 - index)
    const array1 = valueArray.slice(0, 9)
    const firstMod11 = array1.reduce(reducer1, 0) % 11
    const firstCheckDigit = firstMod11 < 2 ? 0 : 11 - firstMod11

    /**
     * Weighted sum of the first 10 digits of the national ID to create the 11th check digit
     * If mod 11 of the weighted sum is less than 2, return 0, else subtract mod 11 of the weighted sum from 11
     */
    const reducer2 = (accumulator, currentValue, index) => accumulator + currentValue * (11 - index)
    const array2 = valueArray.slice(0, 10)
    const secondMod11 = array2.reduce(reducer2, 0) % 11
    const secondCheckDigit = secondMod11 < 2 ? 0 : 11 - secondMod11

    /**
     * Combine the check digits into a two digit number,
     * Compare it with the check digit from the input value
     */
    const checkDigits = firstCheckDigit * 10 + secondCheckDigit
    const inputCheckDigits = Number(value.slice(9, 13))
    return checkDigits === inputCheckDigits
  }
}
